
<ng-container *ngIf="showModal">
	<app-web-kamona-message-widget
		[title]="msgTitle"
		[iconType]="iconType"
		[btnText]="btnText"
		[btnType]="btnType"
		(emitCancel)="handleCloseModal()"
		[suspensionReleaseTimeEpoch]="suspensionReleaseTimeEpoch"
		[description]="msgDescription">
	</app-web-kamona-message-widget>
</ng-container>
<div class="bg-[#F5F5F5] flex justify-center min-h-screen px-[20px]">
    <div class="max-w-[1196px] flex grow flex-col">
        <ng-container *ngTemplateOutlet="header"></ng-container>
        <div class="grow">
            <ng-container *ngTemplateOutlet="body"></ng-container>
        </div>
    </div>
</div>
<ng-template #header>
    <div class="mt-[30px] w-full flex justify-between items-center">
        <div>
            <img src="assets/images/svgs/moniepoint-icon-and-label.svg">
        </div>
        <div class="flex gap-[12px] items-center">
            <div class="text-[14px] leading-[19.6px] text-black font-normal">
                Already have an account?
            </div>
            <div  (click)="goToLogin()" class="bg-[#E6EEFD] cursor-pointer h-[46px] w-[97px] items-center flex justify-center rounded-[8px] py-[11px] px-[16px]">
                <div class="leading-[17.36px] text-[14px] font-medium text-[#0361F0]">
                    Login
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #body>
    <div class="mt-[100px] flex justify-center flex-col">
        <div class="mx-auto w-full grow">
            <ng-container *ngTemplateOutlet="formBody">
            </ng-container>
        </div>
    </div>
</ng-template>

<ng-template #formBody>
    <div class="custom-web-form-wrapper grow !bg-none">
        <div class="basis-1/2 flex justify-end pr-[66px]">
            <div class="flex flex-col gap-[32px]">
                <div class="header">
                    <div class="title">
                        Forgot Password
                    </div>
                    <div class="subtitle">
                        Follow the steps below to recovery your login details
                    </div>
                </div>
                <div>
                    <app-web-kamona-stepper [timelines]="timelines">
                    </app-web-kamona-stepper>
                </div>
            </div>
        </div>
        <div class="basis-1/2">
            <ng-container [ngSwitch]="currentStep">
                <ng-container *ngSwitchDefault>
                    <ng-container *ngTemplateOutlet="stepOne"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="RecoveryStep.PHONE_VERIFICATION">
					<ng-container *ngTemplateOutlet="idVerification"></ng-container>
                </ng-container>
                <ng-container *ngIf="verificationType === AuthenticationType.TWO_FACTOR_AUTHENTICATION">
                  <ng-container *ngSwitchCase="RecoveryStep.LIVELINESS">
                    <ng-container *ngTemplateOutlet="liveliness"></ng-container>
                  </ng-container>
                </ng-container>

                <ng-container *ngSwitchCase="RecoveryStep.ENTER_PASSWORD">
                    <div class="custom-web-form-container">
                        <app-web-kamona-password-widget
                                title="Change Password"
                                oldPasswordPlaceHolder="Enter Password"
                                newPasswordPlaceHolder="Confirm Password"
                                [totalStep]="timelines?.length"
                                [previousTitle]="passwordTimeline?.previousTitle"
                                [minHeight]="231"
								[hideBackBtn]="true"
                                [currentStep]="passwordTimeline?.step"
                                (emitSubmit)="submitPasswordWeb($event)"
                                [submitting]="submitting"
                                description="Please enter a new password to complete recovery"
                                (emitBack)="goToLogin()">
                        </app-web-kamona-password-widget>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
</ng-template>

<ng-template #idVerification>
  <ng-container *ngIf="loading">
    <app-loading loadingText="Loading"></app-loading>
  </ng-container>
  <ng-container *ngIf="!loading">
    <div *ngIf="!livelinessRequired" class="custom-web-form-container">
        <app-web-kamona-otp-widget
                (emitBack)="goToLogin()"
                btnText="Next"
                [ussd]="ussdCode"
                (emitReload)="reloadOtp($event)"
                [minHeight]="289"
                [hideBackBtn]="true"
                [submitting]="submitting"
                (emitSubmit)="handleOtpResponse($event)"
                [description]="otpTimeline?.description"
                [previousTitle]="otpTimeline?.previousTitle"
                [currentStep]="otpTimeline?.step"
                [totalStep]="timelines?.length"
                title="Enter OTP"
                [currentOtpMode]="currentOTPMode || currentOtpModes?.SMS_MODE"
                [canUseWhatsappOTPResend]="useResendOtpViaWhatsapp"
                [canUseNewUssd]="canUseNewUssd"
                [hasResendButtonCountdown]="false"
                [canUseSmsOTPResend]="useResendOtpViaSms"
                [showBothCountDown]="showBothCountDown">
        </app-web-kamona-otp-widget>
    </div>
    <ng-container *ngTemplateOutlet="liveliness"></ng-container>
  </ng-container>
</ng-template>

<ng-template #liveliness>
  <ng-container *ngIf="livelinessRequired">
		<ng-container>
			<app-web-kamona-liveliness-widget
				(emitCancel)="restart()"
				(emitBack)="restart()"
				[flowId]="flowId"
				[metaMapReference]="reference"
				[submitting]="submitting"
				[identityProvider]="provider"
				(emitFinishedMetamapVerification)="handleFinishedMetaMapVerification()"
				(emitFinishedSmileIDVerification)="submitSmileIDJob($event)">
			</app-web-kamona-liveliness-widget>
		</ng-container>
		<ng-container *ngIf="processVerification">
			<app-web-kamona-id-verification
				(emitVerifiedIdentity)="handleVerifiedIdentity($event)"
				(emitFailedIdentity)="handleFailedIdentity($event)"
				[verificationPayload]="verificationPayload"
				[verificationUrl]="idVerificationUrl">
			</app-web-kamona-id-verification>
		</ng-container>
	</ng-container>
</ng-template>

<ng-template #stepOne>
    <ng-container *ngIf="usePhoneNumberForRecovery">
        <app-web-phone-number-recovery
                (emitBack)="goToLogin()"
				[defaultValue]="userTypePayload?.value"
                (emitSubmit)="handleRecovery(LoginTypeRequest.PHONENUMBER)"
                [submitting]="submitting"
                [timelines]="timelines">
        </app-web-phone-number-recovery>
    </ng-container>
    <ng-container *ngIf="!usePhoneNumberForRecovery">
        <app-web-forget-passcode-username-recovery
                (emitBack)="goToLogin()"
                (emitSubmit)="handleRecovery(LoginTypeRequest.USERNAME)"
				[defaultValue]="userTypePayload?.value"
                [submitting]="submitting"
                [timelines]="timelines">
        </app-web-forget-passcode-username-recovery>
    </ng-container>
</ng-template>
